import type { Intent } from '../data/challans';

const intentKeywords: Record<Exclude<Intent, 'help'>, string[]> = {
  amount: ['amount', 'total', 'how much', 'owe', 'due', 'balance', 'money', 'payable', 'rupees', 'rs'],
  status: ['status', 'paid', 'unpaid', 'pending', 'settled', 'cleared', 'is it paid'],
  payment: ['pay', 'payment', 'how do i pay', 'upi', 'card', 'net banking', 'method', 'steps'],
  dueDate: ['due', 'date', 'when', 'deadline', 'last date', 'due date', 'expires'],
};

export function matchIntent(text: string): Intent {
  const normalized = text.toLowerCase().trim();
  if (!normalized) return 'help';

  let best: Intent | null = null;
  let bestScore = 0;

  (Object.keys(intentKeywords) as Array<Exclude<Intent, 'help'>>).forEach((intent) => {
    const keywords = intentKeywords[intent];
    const score = keywords.reduce((sum, keyword) => {
      if (normalized.includes(keyword)) return sum + keyword.length;
      return sum;
    }, 0);

    if (score > bestScore) {
      bestScore = score;
      best = intent;
    }
  });

  return best ?? 'help';
}
